module.exports = __webpack_public_path__ + "img/Confirm detail Illustration.a55519aa.svg";